Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "EXAMPLE_URL";
exports.exampleAPiMethod = "POST";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "Late Delivery Management";
exports.labelBodyText = "Late Delivery Body";

exports.btnExampleTitle = "CLICK ME";

exports.LateDeliveryListPage = {
  title: "Late Delivery Configuration",
  ApiUrls: {
    getLateDeliveryList: "bx_block_orderlatedelivery/late_delivery_configs",
    toggleLateDeliveryStatus: "bx_block_orderlatedelivery/late_delivery_configs"
  },
  Strings: {
    pageTitle: "Late Delivery Configuration",
    addButton: "Add Late Delivery Config",
    name: "Name",
    hours: "Hours",
    color: "Color",
    status: "Status",
    noDataFound: "No records found!!",
    loadingText: "Loading..."
  }
};
// Customizable Area End
